import React from 'react'
import { Row, Col } from 'antd';
import { PROJECTS_ROUTE } from '../../lib/nav'
import StatusSymbol from '../StatusSymbol';

const LineitemBox = ({ lineitem, width, height }) => {

  const { title, extLineItemId, qaState, state, lineItemUUID, projectUUID, user } = lineitem
  const url = PROJECTS_ROUTE + '/' + projectUUID + '/lineItem/' + lineItemUUID;

  const { approvedBy, rejectedBy, assignedTo } = user 
  
  let lastLogEvent = ''
  if (approvedBy !== '') {
    lastLogEvent = `Approved by ${approvedBy}`
  } else if (rejectedBy !== '') {
    lastLogEvent = `Rejected by ${rejectedBy}`
  } else if (assignedTo !== ''){
    lastLogEvent = `Assigned to ${assignedTo}`
  }

  return (
    <Row className="line-item" type="flex" justify="space-around" align="middle" style={{ width: width, height: height}}>
      <Col span={3} className="line-item-status">
        <StatusSymbol status={state} qaState={qaState} nolabel />
      </Col>
      <Col span={17}>
        {title}<br/> 
        <span className='id'>{extLineItemId}<br/> {lastLogEvent}</span>
      </Col>
      <Col span={4}>
        <a href={url} className="axiom-button-button-icon-tertiary">
          <i className="axiom-icon-icon icon-link-2"></i>
        </a>
      </Col>
    </Row>
  )
}

LineitemBox.defaultProps = {
  lineitem: {},
  width: ''
}

export default LineitemBox